<template>
  <transition-group
    enter-active-class="ease-in-out duration-500"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="ease-in-out duration-500"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-show="active"
      @click="$emit('close')"
      class="bg-ontick-carbon-900 fixed inset-0 z-50 bg-opacity-50 transition-opacity"
      aria-hidden="true"
      key="1"
    ></div>

    <div
      v-show="active"
      class="fixed inset-y-0 right-0 z-50 flex max-w-full pl-10"
      key="2"
    >
      <transition
        enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
        enter-class="translate-x-full"
        enter-to-class="translate-x-0"
        leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
        leave-class="translate-x-0"
        leave-to-class="translate-x-full"
      >
        <div v-show="active" class="w-screen max-w-md">
          <div
            class="bg-ontick-carbon-500 flex h-full flex-col overflow-y-scroll bg-opacity-90 shadow-xl backdrop-blur-sm backdrop-opacity-90 backdrop-filter"
          >
            <div
              class="bg-ontick-carbon-500 sticky top-0 bg-opacity-90 px-6 py-3 shadow-lg backdrop-blur-sm backdrop-opacity-90 backdrop-filter"
            >
              <div class="flex items-start justify-between">
                <div class="mr-auto h-7">
                  <button
                    @click="$emit('close')"
                    class="px-1 py-1 text-gray-400 hover:text-gray-400 focus:outline-none"
                  >
                    <span v-html="$icons.arrow_left" />
                  </button>
                </div>
              </div>

              <div class="border-ontick-graphite-700 mb-3 w-full border-b">
                <h2 class="py-3 text-lg font-semibold text-gray-300">
                  Detalhes | {{ strategy.strategy_name }}
                </h2>
              </div>
            </div>

            <div class="chart_stream mt-2 px-6">
              <v-chart
                autoresize
                :options="
                  chartLine(
                    strategy.chart,
                    strategy.position_sl,
                    strategy.position_tp
                  )
                "
              ></v-chart>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition-group>
</template>

<script>
import ECharts from "@/app/shared/components/chart/echarts";

export default {
  props: {
    strategy: {
      type: Object,
    },
    active: { type: Boolean },
  },
  components: {
    "v-chart": ECharts,
  },
  methods: {
    chartLine(value, sl, tp) {
      let option = {
        grid: {
          left: "0%",
          right: "20%",
          bottom: "20%",
          top: "20%",
        },
        xAxis: {
          show: false,
          type: "category",
          boundaryGap: false,
          axisLabel: {
            color: "rgba(255, 255, 255, 0.8)",
            fontSize: 10,
            show: false,
          },
          splitLine: {
            lineStyle: {
              show: false,
            },
            show: false,
          },

          axisLine: {
            symbol: "none",
          },
        },

        tooltip: {
          show: false,
        },

        yAxis: {
          type: "value",
          scale: true,

          axisLabel: { show: false },

          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          minorSplitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "k",
            data: value,
            symbol: "none",
            endLabel: {
              show: true,
              color: "#fff",
              // formatter: function (params) {
              //     // return params.value[3] + ': ' + params.value[0];
              // }
            },
            labelLayout: {
              moveOverlap: "shiftY",
            },
            // markLine: {
            //   silent: true,
            //   data: [
            //     { name: "TP", type: "average", yAxis: tp },
            //     { name: "SL", type: "average", yAxis: sl },
            //   ],
            // },
          },
        ],
      };

      return option;
    },
  },
};
</script>

<style lang="scss">
.chart_stream {
  .echarts {
    height: 150px;
    width: 380px;
  }
}
</style>
